import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
import { Building2, FileCheck, ShieldCheck, Palette } from 'lucide-react';
export function ServiciosComplementariosSection() {
  const {
    lang
  } = useLanguage();
  const services = [{
    icon: <Building2 className="w-[18px] h-[18px] lg:w-6 lg:h-6 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-427" />,
    title: 'LLC en Florida',
    desc: 'Forma tu empresa en Estados Unidos y opera legalmente desde cualquier parte del mundo.',
    descEn: 'Form your company in the United States and operate legally from anywhere in the world.',
    waText: 'Hola! Me interesa saber sobre LLC en Florida'
  }, {
    icon: <FileCheck className="w-[18px] h-[18px] lg:w-6 lg:h-6 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-428" />,
    title: 'Notarización',
    titleEn: 'Notarization',
    desc: 'Documentos notariales certificados en Florida — rápido, seguro y sin complicaciones.',
    descEn: 'Certified notarial documents in Florida — fast, secure, and hassle-free.',
    waText: 'Hola! Me interesa el servicio de Notarización'
  }, {
    icon: <ShieldCheck className="w-[18px] h-[18px] lg:w-6 lg:h-6 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-429" />,
    title: 'Inkova Care',
    desc: 'Tu web siempre activa, actualizada y en buenas manos. Actualizaciones · Mejoras · Soporte.',
    descEn: 'Your website always active, updated, and in good hands. Updates · Improvements · Support.',
    price: 'Desde $150/mes',
    priceEn: 'From $150/mo',
    waText: 'Hola! Me interesa Inkova Care'
  }, {
    icon: <Palette className="w-[18px] h-[18px] lg:w-6 lg:h-6 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-430" />,
    title: 'Brand Kit',
    desc: 'Colores, tipografía y plantillas en Canva para que tu marca sea coherente en cada publicación.',
    descEn: 'Colors, typography, and Canva templates so your brand is consistent in every post.',
    waText: 'Hola! Me interesa el Brand Kit'
  }];
  return <section id="mas-servicios" className="py-12 lg:py-40 bg-white" data-id="element-431">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-432">
        <div className="text-center mb-6 lg:mb-20" data-id="element-433">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-center gap-4 mb-8" data-id="element-434">
            <span className="block w-[1px] h-[40px] bg-inkova-primary/30" data-id="element-435" />
            <span className="inline-block font-sans text-[11px] font-semibold tracking-[3px] uppercase text-inkova-primary" data-id="element-436">
              {lang === 'es' ? 'MÁS SERVICIOS' : 'MORE SERVICES'}
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.1
        }} className="text-[32px] sm:text-[4vw] lg:text-[48px] font-serif text-inkova-dark leading-[1.1] tracking-[-0.5px] mb-6 max-w-[800px] mx-auto" data-id="element-437">
            {lang === 'es' ? <>
                ¿Necesitas algo{' '}
                <em className="italic text-inkova-lavender" data-id="element-438">más?</em>
              </> : <>
                Need something{' '}
                <em className="italic text-inkova-lavender" data-id="element-439">else?</em>
              </>}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="text-[16px] lg:text-[18px] text-inkova-dark/70 font-light leading-[1.8]" data-id="element-440">
            {lang === 'es' ? 'Servicios puntuales que complementan tu negocio digital.' : 'Specific services that complement your digital business.'}
          </motion.p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-8 lg:gap-10" data-id="element-441">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: index * 0.15
        }} className="bg-inkova-cream rounded-[14px] lg:rounded-[24px] p-4 lg:p-10 border border-inkova-border hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(90,69,121,0.12)] transition-all duration-250 flex flex-col w-full" data-id="element-442">
              <div className="w-[36px] h-[36px] lg:w-[64px] lg:h-[64px] rounded-[10px] lg:rounded-full bg-white flex items-center justify-center mb-[10px] lg:mb-8 border border-inkova-border shadow-sm" data-id="element-443">
                {service.icon}
              </div>
              <h3 className="text-[14px] lg:text-[24px] font-sans lg:font-serif font-bold lg:font-medium text-[#1A1A2E] mb-1.5 lg:mb-4" data-id="element-444">
                {lang === 'es' ? service.title : service.titleEn || service.title}
              </h3>
              <p className="text-[12px] lg:text-[15px] text-[#4B5563] lg:text-inkova-dark/70 font-light leading-[1.5] lg:leading-[1.8] mb-4 lg:mb-8 flex-1" data-id="element-445">
                {lang === 'es' ? service.desc : service.descEn}
              </p>

              {service.price && <div className="inline-block bg-white text-inkova-primary text-[11px] lg:text-[12px] font-medium px-3 py-1.5 lg:px-4 lg:py-2 rounded-full mb-3 lg:mb-6 border border-inkova-border self-start tracking-[0.5px]" data-id="element-446">
                  {lang === 'es' ? service.price : service.priceEn}
                </div>}

              <a href={`https://wa.me/13054781618?text=${encodeURIComponent(service.waText)}`} target="_blank" rel="noopener noreferrer" className="text-[#5A4579] lg:text-inkova-primary text-[12px] lg:text-[14px] font-medium flex items-center gap-2 hover:gap-3 hover:text-inkova-lavender transition-all duration-300 group mt-[10px] lg:mt-auto" data-id="element-447">
                <span className="w-4 lg:w-6 h-[1px] bg-inkova-primary group-hover:bg-inkova-lavender transition-colors shrink-0" data-id="element-448" />
                {lang === 'es' ? 'Solicitar información' : 'Request information'}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}